import type { ReportPreviewData } from "../services/signOff.service";
import type { DocumentViewResponse } from "../types/reportTemplate";

export function projectExternalBaselineStains(
  documentViewData: DocumentViewResponse | undefined,
  previewData: ReportPreviewData | undefined,
  hasExternalBaseline: boolean
): DocumentViewResponse | undefined {
  if (!documentViewData || !hasExternalBaseline) {
    return documentViewData;
  }

  const templateContent = documentViewData.template.templateContent;
  if (templateContent.sections.some((section) => section.type === "addendum")) {
    return documentViewData;
  }

  if (
    !templateContent.sections.some((section) => section.type === "stain_table")
  ) {
    return documentViewData;
  }

  const ihcResults = previewData?.ihcResults || documentViewData.ihcResults;
  const specialStainResults =
    previewData?.specialStainResults || documentViewData.specialStainResults;
  if (!ihcResults?.length && !specialStainResults?.length) {
    return documentViewData;
  }

  return {
    ...documentViewData,
    ihcResults,
    specialStainResults,
  };
}
